import { useEffect, useMemo } from "react";

import { useProjectActions, useProjectContext } from "@contexts/projects";

import ProjectionLoadState from "../../financialProjection/ProjectionLoadState";
import EapRuleRow from "./EapRuleRow";
import StepAccordion from "./StepAccordion";

const CellAccordion = ({ parent, months }) => {
  const {
    activeProject: { _id, cells = {} },
    filterDates,
  } = useProjectContext();
  const { loadCells } = useProjectActions();

  useEffect(() => {
    if (_id) loadCells(parent);
  }, [_id, parent, filterDates]);

  const unitCells = useMemo(() => cells[parent], [cells, parent]);

  return (
    <>
      <ProjectionLoadState
        level="cells"
        parent={parent}
        isMissing={!unitCells}
        onRetry={() => loadCells(parent)}
      />
      {unitCells?.map((item) => (
        <EapRuleRow
          key={item.wbs_code_id}
          item={item}
          type="cell"
          typeTitle="Célula construtiva"
          months={months}
          ChildAccordionComponent={StepAccordion}
        />
      ))}
    </>
  );
};

export default CellAccordion;
